export default __webpack_public_path__ + "static/medical-banner-7bc0b97eceb72e0ebad64ddd41d88e93.png";